'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.SystemStatus.CommonServices', 'AVRO.Common.Moment'];
module.exports = angular.module('AVRO.SystemStatus.FlightReopt', dependencies).controller('SystemStatusFlightReoptController', require('./controllers/SystemStatusFlightReoptController')).directive('rmSystemStatusFlightReopt', require('./directives/SystemStatusFlightReoptDirective'));